/* eslint-disable multiline-ternary */
import preact, { Component, h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import TopicLabel from './TopicLabel'
import TopicContent, { getImageUrl } from './TopicContent'
import TopicTooltip from './TopicTooltip'
import TopicListLikeButton from './TopicListLikeButton'
import IdeationStatus from './IdeationStatus'
import TopicViewsCount from '../../control-components/ui-components/TopicViewsCount'
import TopicReplyCount from '../../control-components/ui-components/TopicReplyCount'
import Phrase from '../../libs/translationsUtils/phrase'
import Tooltip from '../../control-components/ui-components/Tooltip'
import { t } from '../../libs/translationsUtils/translations'
import Axios from 'axios'
import qs from 'qs'
import Icon from '../assets'
import LazyLoader from '../lazy-loading/LazyLoader'

type TopicType = 'post' | 'ideation' | 'productUpdate'
type TopicContentType = 'article' | 'question' | 'productUpdate'
interface Post {
  relativeCreationDate: string
  url: string
  author: {
    id: string
    userTitle: string
  }
}

export interface TopicInfo {
  firstPost: Post
  relevantPost: Post
  forum: {
    url: string
    title: string
  }
  featuredImage: string
  contentType: TopicContentType
  content_type?: TopicContentType
  type: TopicType
  isSticky: boolean
  id: number
  url: string
  title: string
  numberOfViews: number
  numberOfReplies: number
  numberOfUnreadReplies: number
  subscriptionId: number
  lastPost: Post
  relativeCreationDate: string
  isTopicUnread: boolean
  hasCurrentUserLiked: boolean
  ideationStatus?: {
    name: string
    bgColor: string
    color: string
  }
}

interface Props {
  isGuest: boolean
  hideCategoryMetadata: boolean
  showUnsubscribeBtn?: boolean
  isActivityPage?: boolean
  topic: TopicInfo
  attachmentCdn: string
  csrfToken?: string
  clickCallback?: (topicId: number, id: number) => void
}

const getMetadataForTopicType = (topicType: TopicType, contentType: TopicContentType) => {
  if (topicType === 'ideation') {
    return <Phrase p='topic.list.metadata.shared.in' />
  } else {
    if (contentType === 'article') {
      return <Phrase p='topic.list.metadata.published.in' />
    } else if (contentType === 'question') {
      return <Phrase p='topic.list.metadata.asked.in' />
    }
    return <Phrase p='topic.list.metadata.posted.in' />
  }
}

const callCallback = (clickCallback: Function|undefined) => {
  if (typeof clickCallback === 'function') {
    clickCallback()
  }
}

class TopicListItemView extends Component<Props> {
  constructor (props: Props) {
    super(props)

    this.handleFavoriteRemoval = this.handleFavoriteRemoval.bind(this)
  }

  ref: preact.RefObject

  async handleFavoriteRemoval () {
    await Axios.post('/favorite/delete', qs.stringify({
      yip_csrf_token: this.props.csrfToken,
      threadid: this.props.topic.id
    }))

    this.ref.classList.add('remove-favorite')
    window.setTimeout(() => {
      this.ref.parentNode.parentNode.removeChild(this.ref.parentNode) // Remove `date-preact` component
    }, 250)
  }

  render (props: Props) {
    const { isGuest, topic, attachmentCdn, hideCategoryMetadata, clickCallback, showUnsubscribeBtn, isActivityPage } = props

    const { type, contentType, isSticky, id: topicId, relevantPost, url: topicUrl, featuredImage, title: topicTitle, numberOfViews, numberOfReplies, numberOfUnreadReplies, firstPost, forum, lastPost, isTopicUnread, hasCurrentUserLiked } = topic
    const author = firstPost.author
    const { id: userId, userTitle } = author
    const { url: forumUrl, title: forumTitle } = forum
    const { url: lastPostUrl, author: lastPostAuthor, relativeCreationDate: lastPostRelativeCreationDate } = lastPost
    const topicCategoryMetadata = getMetadataForTopicType(type, contentType)
    const redirectUrl: string = isActivityPage ? relevantPost.url : topic.url

    return (
      <div
        className={`qa-topic-block topic-view js-thread js-thread-id-${topic.id}
            ${isTopicUnread ? 'topic-view--unread' : ''}
            ${isSticky ? 'topic-view--sticky' : ''}
            ${type === 'ideation' ? 'topic-view--ideation' : ''}`}
        ref={(ref) => { this.ref = ref }}
      >
        <a className='topic-view_link' href={redirectUrl} />
        {
          isSticky
            ? (
              <Icon icon='stickyFlag' />
              )
            : null
        }
        <div className='topic-view_header'>
          <div className='topic-view_header-item'>
            <UserAvatar
              user={author}
              extraClass='avatar'
              showRank
            />
          </div>
          <div className={`topic-view_header-items-gathered ${hideCategoryMetadata ? 'topic-view_header-items_without-category' : ''}`}>
            <div className='topic-view_header-item'>
              <UserName
                user={author}
                extraClass='username'
              />
              {userId && userTitle ? <span className='user-title text--meta'>{author.userTitle}</span> : ''}
            </div>
            {
              !hideCategoryMetadata
                ? (
                  <a href={forumUrl} className='topic-view_header-item text--meta'>
                    <span>{topicCategoryMetadata}</span>&nbsp;
                    <span className='topic-view_header-item_category-link'>
                      {forumTitle}
                    </span>
                  </a>
                  )
                : null
            }
          </div>
        </div>
        <div className='topic-view_info'>
          {
            featuredImage
              ? (
                <LazyLoader type='background' src={getImageUrl(topic.featuredImage, '480', attachmentCdn)} classNames='thread-list-block__featured-image-link' />
                )
              : null
          }
          <div className='topic-view_body-container'>
            <div className='topic-view_body' onClick={() => { callCallback(clickCallback) }}>
              <h4 className='thread-list-block__title'>
                <a
                  href={topicUrl}
                  className='qa-topic-title thread-list-block__title-link'
                >
                  {topicTitle}
                </a>

                <TopicLabel
                  topic={topic}
                />

                {
                  type === 'ideation' && <IdeationStatus topic={topic} />
                }
                {
                  topic.type !== 'ideation'
                    ? (
                      <TopicTooltip
                        topic={topic}
                      />)
                    : null
                }
              </h4>

              <TopicContent
                topic={{ ...topic, ...{ url: redirectUrl } }}
                attachmentCdn={attachmentCdn}
              />
            </div>
            <div className='topic-view_footer'>
              {
                showUnsubscribeBtn
                  ? (
                    <Tooltip
                      trigger={
                        <i
                          aria-hidden='true'
                          className='icon--star-full icon--auto-width thread-meta-item__icon thread-meta-item__text--highlight qa-topic-meta-favorite-icon'
                          onClick={this.handleFavoriteRemoval}
                        />
}
                    tooltipMessage={t('Forum', 'thread.unsubscribe')} //eslint-disable-line
                      qaClasses='qa-title-tooltip'
                    />
                    ) : null
              }

              <TopicListLikeButton
                topic={topic}
                isGuest={isGuest}
                hasCurrentUserLiked={hasCurrentUserLiked}
              />
              {
                topic.contentType === 'article' || topic.contentType === 'productUpdate'
                  ? (
                    <span className='thread-meta-item thread-meta-item--hover-highlight is-hidden-S'>
                      <a className='qa-topic-meta-views' href={topicUrl}>
                        <TopicViewsCount views={numberOfViews} />
                      </a>
                    </span>)
                  : null
              }

              <span className='thread-meta-item thread-meta-item--comments thread-meta-item--hover-highlight'>
                <a className='qa-topic-meta-replies-icon' href={lastPostUrl}>
                  <TopicReplyCount replyCount={numberOfReplies} />
                </a>

                {
                  numberOfUnreadReplies
                    ? (
                      <span className='thread-meta-item__text thread-meta-bullet'>
                        <span className='icon--bullet icon--auto-width' />
                      </span>)
                    : null
                }

                {
                  numberOfUnreadReplies
                    ? (
                      <a
                        className='thread-meta-item__text--highlight qa-topic-meta-new'
                        href={`/topic/firstNewPostRedirect?topicId=${topicId}`}
                      >
                        <span className='thread-meta-item__text--highlight'>
                          <Phrase p='forumList.meta.counter.post.user.new' count={{ n: numberOfUnreadReplies.toString() }} />
                        </span>
                      </a>)
                    : null
                }
              </span>

              <span className='thread-meta-item thread-meta-item--last-update thread-meta-item--hover-highlight'>
                <UserAvatar
                  user={lastPostAuthor}
                  extraClass='avatar--XS thread-meta-item__icon'
                  showRank
                />

                <a
                  className='qa-topic-meta-last-post-date-link'
                  href={lastPostUrl}
                >
                  <span className='thread-meta-item__text'>
                    {lastPostRelativeCreationDate}
                  </span>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TopicListItemView
